// FE#216 — relative-time label for the "last synced" hint shown next to the
// contact-search refresh button. Pure + framework-free so it unit-tests without
// a render harness (mirrors the message-status helpers' testability).
//
// Returns null when there is no sync timestamp yet (nothing to show). Otherwise
// a short human label: "Just now" / "N min ago" / "N hr ago" / "N days ago", and
// a locale date for anything older than a week.
export function formatLastSyncedLabel(
  timestampMs: number | null | undefined,
  nowMs: number,
): string | null {
  if (timestampMs == null || !Number.isFinite(timestampMs)) return null;

  const deltaMs = Math.max(0, nowMs - timestampMs);
  const sec = Math.floor(deltaMs / 1000);
  if (sec < 45) return 'Just now';

  const min = Math.floor(sec / 60);
  if (min < 1) return 'Just now';
  if (min < 60) return `${min} min ago`;

  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr} hr ago`;

  const day = Math.floor(hr / 24);
  if (day < 7) return `${day} day${day === 1 ? '' : 's'} ago`;

  return new Date(timestampMs).toLocaleDateString();
}
